import styled from 'styled-components';
import Row from 'react-bootstrap/Row';

export default styled(Row)`
  margin-bottom: 2em;
`;
